module.exports = __webpack_public_path__ + "img/trophy.633c22cc.svg";